import React, { useMemo } from "react";
import { useDroppable } from "@dnd-kit/core";
import { Box, Typography, type BoxProps } from "@mui/material";

type DroppableProps = {
  dndId: string | number;
  disabled?: boolean;
  data?: Record<string, unknown>;
  droppedValue?: React.ReactNode;
  placeholder?: React.ReactNode;
  subPlaceholder?: React.ReactNode;
  sx?: BoxProps["sx"];
};

function Droppable({
  dndId,
  disabled = false,
  data,
  droppedValue,
  placeholder = "Drag & Drop Here",
  subPlaceholder = null,
  sx = {},
}: DroppableProps) {
  const formattedPlaceholder = useMemo(() => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography variant="caption" fontWeight={600}>
          {placeholder}
        </Typography>
        {subPlaceholder && (
          <Typography variant="caption" fontWeight={500}>
            {subPlaceholder}
          </Typography>
        )}
      </Box>
    );
  }, [placeholder, subPlaceholder]);

  const { setNodeRef, isOver } = useDroppable({
    id: dndId,
    data,
    disabled,
  });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        background: (theme) =>
          isOver
            ? `color-mix(in srgb, ${(theme.vars || theme).palette.common.black} 13.333333333333334%, transparent)`
            : theme.palette.primary.light,
        height: "100px",
        ...sx,
      }}
    >
      {droppedValue || formattedPlaceholder}
    </Box>
  );
}

export default Droppable;
